import { createAction, props } from '@ngrx/store';
import { LicenseConfiguration } from '../license-configuration';

export const licenseConfigurationGet = createAction('[License Configuration] Get');

export const licenseConfigurationGetSuccess = createAction(
  '[License Configuration] Get Success',
  props<{ payload: LicenseConfiguration }>(),
);

export const licenseConfigurationGetFail = createAction(
  '[License Configuration] Get Fail',
  props<{ payload?: any }>(),
);

export const licenseGetName = createAction('[License Configuration] Get Name');

export const licenseGetNameSuccess = createAction(
  '[License Configuration] Get Name Success',
  props<{ payload: string }>(),
);

export const licenseGetNameFail = createAction(
  '[License Configuration] Get Name Fail',
  props<{ payload?: any }>(),
);

export const licenseLoadExtensions = createAction('[License Configuration] Load Extensions');

export const licenseLoadExtensionsSuccess = createAction(
  '[License Configuration] Load Extensions Success',
  props<{ licenseExtensions: string[] }>(),
);

export const licenseLoadExtensionsFail = createAction(
  '[License Configuration] Load Extensions Fail',
  props<{ payload?: any }>(),
);
